export class MarketplaceItemMapping {
  public AttributeMappingId: number;
  public StockCount: number;
  public AvailableStockCount: number;
  public DisplayName: string;
  public UnlimitedStock: boolean;
}
